import { render, staticRenderFns } from "./Info_ImportantSection.vue?vue&type=template&id=30d7c02f&scoped=true&"
import script from "./Info_ImportantSection.vue?vue&type=script&lang=js&"
export * from "./Info_ImportantSection.vue?vue&type=script&lang=js&"
import style0 from "./Info_ImportantSection.vue?vue&type=style&index=0&id=30d7c02f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30d7c02f",
  null
  
)

export default component.exports